import { render, staticRenderFns } from "./courseQuestionBank.vue?vue&type=template&id=9877e902"
import script from "./courseQuestionBank.vue?vue&type=script&lang=js"
export * from "./courseQuestionBank.vue?vue&type=script&lang=js"
import style0 from "./courseQuestionBank.vue?vue&type=style&index=0&id=9877e902&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports